module.exports = __webpack_public_path__ + "img/appStore.69cf0e1.svg";